// resources/js/components/Header.js

import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import '/css/app.css';
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

import logo_jesa_tp from '/images/logo_JESA_transparent-white-bottom_v02.webp';


export default function Header() {
    return (
        // <BrowserRouter>
            <div className="row d-flex justify-content-center bg-verylightgray schum-color sticky-top">
                <div className="col-md-9 mb-1 mt-1 fs-6 fw-bold">
                    <div className="row  d-flex align-items-center justify-content-around mx-0">
                        <div className="col-auto p-0"><Link to="/"><img src={logo_jesa_tp} className="logo_jesa_tp" alt="J.E.Schum Asia Ltd. Logo"/></Link></div>
                        <div className="col-auto p-0"><Link to="/" className="text-decoration-none text-reset">Home</Link></div>
                        <div className="col-auto p-0"><Link to="/about" className="text-decoration-none text-reset">About us</Link></div>
                        <div className="col-auto p-0"><Link to="/quality" className="text-decoration-none text-reset">Quality</Link></div>
                        <div className="col-auto p-0"><Link to="/contact" className="text-decoration-none text-reset">Contact</Link></div>
                        
                        {/* <div>More</div> */}
                        {/* <div>Login</div> */}
                    </div>
                </div>
            </div>
        // </BrowserRouter>
    );
}

if (document.getElementById('header')) {
    const container = document.getElementById('header');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<Header />);
}